import logo from '@/assets/logo-cuu-long.webp'

// product source
import product1 from '@/assets/day-thung.webp'
import product2 from '@/assets/luoi-an-toan.webp'
import product3 from '@/assets/day-dai.webp'
import product4 from '@/assets/day-cuong.webp'
import product5 from '@/assets/tham-pp.webp'
import product6 from '@/assets/chi-may-bao-bi.webp'

// customer
import customer1 from '@/assets/customer/customer-1.webp'
import customer2 from '@/assets/customer/customer-2.webp'
import customer3 from '@/assets/customer/customer-3.webp'
import customer4 from '@/assets/customer/customer-4.webp'
import customer5 from '@/assets/customer/customer-5.webp'

// hero
import hero from '@/assets/other/hero.webp'
import section1 from '@/assets/other/section.webp'

// section
import section from "@/assets/section/section-1.webp"
import section2 from "@/assets/section/section-2.webp"
import section3 from "@/assets/section/section-3.webp"
import section4 from "@/assets/section/section-4.webp"
import section5 from "@/assets/section/section-5.webp"
import section6 from "@/assets/section/section-6.webp"

export const LIST_IMAGE = {
    logo,
    product1,
    product2,
    product3,
    product4,
    product5,
    product6,
    customer1,
    customer2,
    customer3,
    customer4,
    customer5,
    hero,
    section1,
    section,
    section2,
    section3,
    section4,
    section5,
    section6
}